module.exports = __webpack_public_path__ + "src/assets/textures/env/dirt_inner/dirt_inner_4k_bake.png";